import { FunctionalComponent, h } from 'preact';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { ButtonComponent } from 'common/module/button/component';
import { ButtonComponentTypeEnum } from 'common/module/button/component-type.enum';
import { IconCloseTemplate } from 'common/module/icon';
import { MyAccountConfirmationTemplatePropsInterface } from 'common/module/my-account/confirmation/template-props.interface';

export const MyAccountConfirmationTemplate: FunctionalComponent<MyAccountConfirmationTemplatePropsInterface> = (
  props
) => (
  <div className='modal-confirmation__wrapper'>
    <header className='modal-confirmation__header modal-confirmation__separator modal-confirmation__separator--top'>
      <h1 className='modal-confirmation__header-title'>{props.title}</h1>
    </header>
    <div className='save-search-form__content'>{props.description}</div>
    <footer className='save-search-form__footer modal-confirmation__separator modal-confirmation__separator--bottom'>
      <ButtonComponent
        cssClass='save-search-form__button'
        componentType={ButtonComponentTypeEnum.type1}
        onClick={props.onClickReject}
      >
        {i18nTranslate('Cancel')}
      </ButtonComponent>
      <ButtonComponent
        cssClass='save-search-form__button'
        componentType={ButtonComponentTypeEnum.type2}
        onClick={props.onClickApprove}
      >
        {i18nTranslate('Delete all')}
      </ButtonComponent>
    </footer>
    <div className='modal-confirmation__close' onClick={props.onClickReject}>
      <IconCloseTemplate class={'modal-confirmation__close-icon'} />
    </div>
  </div>
);
